export default {
    // // Hi-fi Isometric - End of the Skyline
    // "canvas": {
    //     "width": 16 * 135,
    //     "height": 9 * 135,
    //     "isPixelated": false,
    // },
    // "grid": {
    //     "width": 276,
    //     "height": 159,
    //     "depth": 159,
    // },
    // "camera": {
    //     "type": "isometric",
    //     "position": {
    //         "x": Math.round((16 * 135) / 2),
    //         "y": Math.round(((9 * 135) / 3)) + 50,
    //     }
    // },

    // // Lo-fi Top-down - Hero Tactics
    // "canvas": {
    //     "width": 16 * 16,
    //     "height": 9 * 16,
    //     "isPixelated": true,
    // },
    // "grid": {
    //     "width": 16,
    //     "height": 16,
    //     "depth": 16,
    // },
    // "camera": {
    //     "type": "top-down",
    //     "position": {
    //         "x": (((16/2) - (6/2)) * 16) + (16 * 0.5),
    //         "y": (((9/2) - (6/2)) * 16) + (16 * 1)
    //     },
    // },

    // // Lo-fi Top-down Tilt - Bomberbro Tileset
    // "canvas": {
    //     "width": 16 * 24,
    //     "height": 9 * 24,
    //     "isPixelated": true,
    // },
    // "grid": {
    //     "width": 24,
    //     "height": 24,
    //     "depth": 24,
    // },
    // "camera": {
    //     "type": "top-down",
    //     "position": {
    //         "x": (24 * -0.5), // (16 * 24) * -0.5,
    //         "y": (24 * -1), // (9 * 24) * -0.5,
    //     },
    // },

    // // Lo-fi Top-Down - Saltsman's Tileset
    // "frame": {
    //     "width": 16,
    //     "height": 9,
    // },
    // "canvas": {
    //     "width": (16 * 1.5) * 8,
    //     "height": (9 * 1.5) * 8,
    //     "isPixelated": true,
    // },
    // "grid": {
    //     "width": 8,
    //     "height": 8,
    //     "depth": 8,
    // },
    // "camera": {
    //     "type": "top-down",
    //     "position": {
    //         "x": ((((32/2) - (16/2)) * 8) + (8 * 0.5)) * -1,
    //         "y": ((((16/2) - (9/2)) * 8) + (8 * 1)) * -1
    //     },
    // },
    // "defaultAnchor": {
    //     "x": 0.5,
    //     "y": 1,
    // }

    // Lo-fi Top-Down - Saltsman's Tileset
    "frame": {
        "width": 8,
        "height": 8,
    },
    "canvas": {
        "width": 64,
        "height": 64,
        "isPixelated": true,
    },
    "grid": {
        "width": 8,
        "height": 8,
        "depth": 8,
    },
    "camera": {
        "type": "top-down",
        "position": {
            "x": ((((32/2) - (16/2)) * 8) + (8 * 0.5)) * -1,
            "y": ((((16/2) - (9/2)) * 8) + (8 * 1)) * -1
        },
    },
    "defaultAnchor": {
        "x": 0.5,
        "y": 1,
    }

    // // Lower-res Isometric - Cryptozootography
    // "canvas": {
    //     "width": 16 * 135,
    //     "height": 9 * 135,
    //     "isPixelated": false,
    // },
    // "grid": {
    //     "width": 256,
    //     "height": 128,
    //     "depth": 80,
    //     // "depth": 63,
    // },
    // "camera": {
    //     "type": "isometric",
    //     "position": {
    //         "x": Math.round((16 * 135) * -0.5),
    //         "y": Math.round(((9 * 135) * -0.45)),
    //     }
    // },
}
